import { ButtonBase } from "@mui/material";
import { InputNumber } from "antd";
import { useEffect } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

const AdminFeeComp = () => {
  const { control, register } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "adminfees",
  });
  const handleAddItem = () => {
    append({ admin_fee: "", minimum_loan_amount: "", maximum_loan_amount: "" });
  };

  const handleRemoveItem = (index) => {
    remove(index);
  };
  // console.log("CMOMP CALLED", fields);
  return (
    <>
      {fields.map((field, index) => {
        return (
          <div
            className="flex flex-wrap items-center gap-[10px] mt-[16px]"
            key={field.id}
          >
            <div className="flex items-center gap-[10px] max-[700px]:w-[100%]">
              <div>
                <label className="block mb-[6px] text-[13px] text-[#495159]">
                  Fee amount
                </label>
                <Controller
                  control={control}
                  name={`adminfees.[${index}].admin_fee`}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <InputNumber
                        type="number"
                        min={0}
                        prefix="$"
                        prefixCls="num_pref_icon"
                        style={{ borderColor: "#C3D2E2" }}
                        {...field}
                        step="1.00"
                        precision={2}
                        placeholder="0.00"
                        className={`cusAdmInputNumber`}
                        onChange={(data) => field.onChange(data)}
                        defaultValue={field.admin_fee}
                      />
                    );
                  }}
                />
              </div>
              <div>
                <label className="block mb-[6px] text-[13px] text-[#495159]">
                  Loan amount
                </label>
                <Controller
                  control={control}
                  name={`adminfees.[${index}].minimum_loan_amount`}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <InputNumber
                        type="number"
                        min={0}
                        style={{ borderColor: "#C3D2E2" }}
                        {...field}
                        prefix="$"
                        prefixCls="num_pref_icon"
                        step="0.01"
                        precision={2}
                        onChange={(data) => field.onChange(data)}
                        placeholder="Minimum"
                        className={`cusAdmInputNumber`}
                        defaultValue={field.minimum_loan_amount}
                      />
                    );
                  }}
                />
              </div>
              <span className="mx-[10px] mt-[24px]">to</span>
            </div>
            <div className="mt-[24px] max-[700px]:mt-[10px]">
              <Controller
                control={control}
                name={`adminfees.[${index}].maximum_loan_amount`}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <InputNumber
                      type="number"
                      min={0}
                      style={{ borderColor: "#C3D2E2" }}
                      {...field}
                      step="0.01"
                      prefix="$"
                      prefixCls="num_pref_icon"
                      precision={2}
                      onChange={(data) => field.onChange(data)}
                      placeholder="Maximum"
                      className={`cusAdmInputNumber`}
                      defaultValue={field.maximum_loan_amount}
                    />
                  );
                }}
              />
            </div>

            {index === 0 && (
              <ButtonBase
                disableTouchRipple
                disabled={fields.length >= 3}
                className={`${fields.length >= 3 && "opacity-[0.5]"}`}
              >
                <span
                  className="cursor-pointer mt-[24px] max-[700px]:mt-[10px]"
                  onClick={handleAddItem}
                >
                  <img src="/images/fi_plus-circle2.svg" alt="add icon" />
                </span>
              </ButtonBase>
            )}

            {fields.length > 1 && (
              <span
                className="cursor-pointer mt-[24px] max-[700px]:mt-[10px]"
                onClick={() => handleRemoveItem(index)}
              >
                <img src="/images/fi_minus-circle2.svg" alt="add icon" />
              </span>
            )}
          </div>
        );
      })}
    </>
  );
};

export default AdminFeeComp;
